import Vue from "vue";
import VueI18n from "vue-i18n";
import zn from "./language/zn.js";
import en from "./language/en.js";
import locale from "element-ui/lib/locale";
import elementEN from "element-ui/lib/locale/lang/en"; // 引入饿了么的英文包
import elementZH from "element-ui/lib/locale/lang/zh-CN"; // 引入饿了么的中文包
Vue.use(VueI18n); // 全局注册国际化包

// 准备翻译的语言环境信息
const i18n = new VueI18n({
  locale: localStorage.getItem("lang") || "zn", // 初始化中文；
  messages: {
    zn: {
      ...zn,
      ...elementZH,
    },
    en: {
      ...en,
      ...elementEN,
    },
  },
});
locale.i18n((key, value) => i18n.t(key, value));
export default i18n;
